/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * GST-exclusive price on the product page.
 *
 * NZ GST is 15%, so ex-GST = GST-inclusive price / 1.15. The <span data-ex-gst>
 * in snippets/product-variant-selector.liquid is rendered server-side from the
 * real variant price, so it is correct on load. This only updates it when the
 * customer switches variant, using the authoritative price from the
 * `variant:changed` event (in cents) - it does NOT scrape the rendered page,
 * which previously read the wrong element and showed the same value everywhere.
 */
document.addEventListener('variant:changed', function (event) {
  var variant = event && event.detail && event.detail.variant;
  if (!variant || typeof variant.price !== 'number') return;
  var exGst = '$' + (variant.price / 100 / 1.15).toFixed(2);
  document.querySelectorAll('[data-ex-gst]').forEach(function (el) {
    if (el.textContent !== exGst) el.textContent = exGst;
  });
});
